// removed by extract-text-webpack-plugin
module.exports = {"loginPage":"_29OrYvfMUhaO3hHqqWg6A_","backgroundImg":"_25g7MwlrcZek5Sqvhfg9PA"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Login/Login.scss
 ** module id = 992
 ** module chunks = 0
 **/